import React from 'react';
import Select from './Select';

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 30,
  onPageChange,
  onItemsPerPageChange,
  className = '',
}) => {
    // Ensure itemsPerPage is a valid number
    const validItemsPerPage = !isNaN(itemsPerPage) && itemsPerPage > 0 ? itemsPerPage : 30;
    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * validItemsPerPage + 1;
    const endItem = Math.min(currentPage * validItemsPerPage, totalItems);

    const getPageNumbers = () => {
      const pages = [];
      const maxPagesToShow = 5;
      if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 3) {
          for (let i = 1; i <= 4; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage >= totalPages - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = totalPages - 3; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(totalPages);
        }
      }
      return pages;
    };

    const handlePageClick = (page) => {
      if (page !== '...' && page !== currentPage && page >= 1 && page <= totalPages) {
        onPageChange(page);
      }
    };

    // if (totalPages <= 1) {
    //   return null;
    // }

    return (
      <div className={`relative z-20 bg-white border-t border-gray-200 shadow-sm flex items-center justify-between px-6 py-2 flex-shrink-0 ${className}`}>
        {/* Left: Entries info */}
        <div className="flex-1">
          <div className="text-sm text-gray-600">
            Showing <span className="font-semibold text-gray-900">{startItem}</span> to <span className="font-semibold text-gray-900">{endItem}</span> of <span className="font-semibold text-gray-900">{totalItems}</span> entries
          </div>
        </div>

        {/* Center: Page navigation */}
        <div className="flex-1 flex justify-center">
          {totalPages > 1 && (
            <div className="flex gap-1 items-center">
              <button
                className="px-2 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
                title="Previous page"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <div className="flex gap-1">
                {getPageNumbers().map((page, index) => (
                  <button
                    key={index}
                    className={`min-w-[2rem] px-2.5 py-1 text-sm font-medium rounded-md transition-all ${
                      page === currentPage
                        ? 'text-white bg-primary-600 border border-primary-600'
                        : page === '...'
                        ? 'text-gray-500 bg-white border border-transparent cursor-default'
                        : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                    }`}
                    onClick={() => handlePageClick(page)}
                    disabled={page === '...'}
                    title={page === '...' ? '' : `Go to page ${page}`}
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button
                className="px-2 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
                title="Next page"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          )}
        </div>

        {/* Right: Items per page selector */}
        <div className="flex-1 flex justify-end items-center">
          {onItemsPerPageChange && (
            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Rows per page:</span>
              <div className="-mb-4" style={{ minWidth: '100px', maxWidth: '100px' ,marginBottom:'0.5px'}}>
                <Select
                  value={Number(validItemsPerPage)}
                  onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                  searchable={false}
                  showClearButton={false}
                  dropdownDirection="up"
                  placeholder="Select"
                  options={[
                    { value: 30, label: '30  / page' },
                    { value: 50, label: '50  / page' },
                    { value: 100, label: '100 /page' }
                  ]}
                />
              </div>
            </div>
          )}
        </div>
      </div>

    );
  }

  export default Pagination;


